export default "__VITE_ASSET__DCIwUdDi__"